import { spacing, breakpoints } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import styled from '@emotion/styled';
import { AccordionBlockWrapper } from '@components/SectionBlocks/blocks/AccordionBlock';
import { Container as IframeBlockContainer } from '@components/SectionBlocks/blocks/IframeBlock';
import { LivestreamBlockWrapper } from '@components/SectionBlocks/blocks/LivestreamBlock';
import { HeadContainer as NewsfeedHeaderContainer } from '@components/SectionBlocks/blocks/NewsFeedBlock/NewsFeedBlock.styles';
import { HeaderContainer as QnaHeaderContainer } from '@components/SectionBlocks/blocks/QnaFeedBlock/Header';
import { TextBlockContainer } from '@components/SectionBlocks/blocks/TextBlock';
import { ChartWrapper } from '@components/SectionBlocks/Testshowcase/Results/Styles';
import { ShowcaseBlockWrapper } from '@components/SectionBlocks/Testshowcase/ShowcaseBlock';
import { BlockHeader as ColumnBlockHeader } from '@components/SectionBlocks/blocks/MultiRowArticleBlock';
import { ColumnWrapper, IngressText as ColumnBlockIngressText } from '@components/SectionBlocks/ColumnBlock.styles';

export const LeftColumn = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 2 0 calc(66% - 2 / 3 * ${spacing.space48});
  box-sizing: content-box;
  width: 90%;

  @media (width <= calc(${breakpoints.xl} + 9px)) {
    flex-basis: 100%;
  }

  @media (width > ${breakpoints.m}) {
    ${ShowcaseBlockWrapper},
    ${LivestreamBlockWrapper}, ${NewsfeedHeaderContainer}, ${QnaHeaderContainer}, ${IframeBlockContainer} {
      h1,
      h1 + p {
        max-width: 50ch;
      }
    }

    ${AccordionBlockWrapper} {
      h2,
      h2 + p {
        max-width: 50ch;
      }
    }

    ${ColumnBlockHeader} h2,
    ${ColumnBlockIngressText} {
      max-width: 60ch;
    }

    ${TextBlockContainer} {
      max-width: 75ch;
    }

    ${ChartWrapper} {
      h2,
      h2 + p {
        max-width: 50ch;
      }
    }
  }

  ${ColumnWrapper} {
    @media (max-width: ${breakpoints.m}) {
      width: calc(100vw - 48px);
      margin: -${spacing.space4} -${spacing.space24};
      padding: ${spacing.space4} ${spacing.space24};
    }
  }
`;

export const RightColumn = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 0 calc(33% - 1 / 3 * ${spacing.space48});

  @media (width <= calc(${breakpoints.xl} + 9px)) {
    display: none;
  }
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  flex-grow: 1;
  box-sizing: border-box;
  column-gap: ${spacing.space48};
  margin: 0 auto;
  min-height: 50vh;
  background-color: ${nafColor.signature.white};
  border-radius: ${spacing.space4};
  padding: ${spacing.space24} ${spacing.space40};

  @media (width > ${breakpoints.m}) {
    width: 90%;
    max-width: 1600px;
  }

  @media (max-width: ${breakpoints.m}) {
    width: 100%;
    padding: ${spacing.space24};
  }
`;

export const PageContent = styled.div<{ $backgroundSrc?: string }>`
  min-height: 100vh;
  ${({ $backgroundSrc }) => ($backgroundSrc ? `background-image: url('${$backgroundSrc}');` : '')}
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100% auto;

  @media (height >= 69vw) {
    /* Approximation of viewport aspect-ratio 1.45 */
    background-size: auto 80vh;
  }
`;

export const FeedbackContainer = styled.div`
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 ${spacing.space40} ${spacing.space64} ${spacing.space40};

  @media (width > ${breakpoints.m}) {
    width: 90%;
    max-width: 1600px;
  }

  @media (width <= ${breakpoints.m}) {
    width: 100%;
    padding: 0 ${spacing.space24} ${spacing.space64} ${spacing.space24};
  }
`;
